<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="75px" height="75px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
    <image id="image0" width="100" height="100" x="0" y="0" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
      AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAACH1BMVEUAAAD/hwD/hQD/hgD/
      hgD/hgD/hQD/hgD/hgD/mQD/gwD/hgD/hQD/hQD/hgD/iAD/hQD/hgD/hAD/hQD/hgD/fwD/hQD/
      hQD/qgD/fwD/hAD/hgD/hQD/hgD/hgD/hQD/hAD/hQD/hQD/hAD/fwD/hgD/hQD/hgD/hQD//wD/
      hAD/hgD/hQD/hQD/hQD/fwD/hgD/hQD/hwD/hgD/hQD/hQD/hQD/hgD/hgD/hAD/hgD/hgD/hwD/
      iAD/hQD/hgD/hQD/hQD/fwD/hQD/hQD/hQD/hAD/hgD/hwD/hgD/hQD/hgD/hwD/hgD/hQD/hgD/
      jAD/jQD/hgD/hgD/hQD/hQD/hwD/hQD/iQD/hQD/hQD/iAD/hQD/hgD/hQD/hQD/hgD/hQD/hAD/
      hAD/hgD/hQD/hQD/hgD/hAD/kQD/hgD/igD/fwD/hQD/fwD/iAD/hgD/hQD/hgD/hgD/hAD/hgD/
      hQD/hgD/hwD/hgD/iAD/hgD/gwD/hAD/iwD/hwD/hgD/hQD/hQD/hQD/hQD/hQD/fwD/fwD/hwD/
      hQD/hgD/hgD/hgD/hgD/hQD/hQD/hgD/hgD/hgD/iAD/hQD/hQD/hQD/hgD/hQD/hgD/hQD/hgD/
      hgD/hQD/hQD/hQD/hgD/hAD/hQD/hgD/hQD/hQD/iQD/hQD/hQD/hQD/hgD/hgD/hgD/hgD/hgD/
      hwD/hQD/hwD/hgD/hgD///+DkD8nAAAAs3RSTlMAL4vL7/HUpUwFHa/+30Y864oy8oUK21wDDjiU
      +llwhjDn7hsG4p73uQFi9RVxawLXkU/A9Oy7SLpHviZTHoh/8MgEyqBFXn1E/SqtM7yu8xQJNTmP
      m0IoDd3hD8yMPaL5VE1Lidn8+0kH0RgSYxAruKTEkGDazm4+hxzcITYLUYGxLENz0gwIZPZX3nTY
      w+lqebIp+G+1tJ2cUO1hZ9BtThll6j+ZGmmzxmjNxWzTQBdmml7U+TkAAAABYktHRLRECWrdAAAA
      CXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH6QcZEAULlC2qUgAAA9xJREFUaN7tl/0jFEEYx9db
      5SUpvRChEr3gxJ23KFLpUEoUUg6VvJSQ6Ije6L2UkyhdJyHp9f7BnmfXntvZu72Z6+6Har8/3M3M
      83znszs7OzPLcapUqVKlSpWq/0g+vn7+VhcKWLFyVaD7iKDgEFeEJa0OdZexJowSAQpZ6x5jXTg9
      A7TeHcaGjWj12xQUIWnGRmli5OaoaGzd4gYkBo2xEWSzHAKK2wqt27YzM+J3gC9B3u4QwvkkQvPO
      XayQ3eDak0QL4ZKxPYWRoUkF016+mJau1WVkOoJgJCtbyM/Bi9rHBskFT3QelvYLk+eAHCKJ5OVD
      seAgE6QQLIf4qxWnaCgJsUUO89UjWCxiYRwFg74YS+liVzkkhIyU4M2XMkCOgeE4XyoTuwonIWTk
      BM7j1JPUjHL0nuKLAWJX+SSEjHDZuNJVUENKlgchQ+wqi4SQEY6rxEE+Tck4o19+0JlOHzwZ4biq
      aqjVnKWDJEBurVg5J/Tky5EQMgI6j1dXR8UIMkBq/VKlQSd0FdZIQsgI6gI25NJAKiDxokYoN14S
      B6XpshQii6CaW5Da6prRhnPzilC+ardv6drsIfIIr3ZcKa8prpSB9R2pWqatyrE6u67HOdv207o9
      ABBluJHQ0yubaZqbHkSIqi4pajDaQbzBENTX1S+OFS4KiRW3BqimuaL6B2/fqZFgmmLj+WeOz6Pm
      7p8TbJP03v26oSYbJn0Y2urxPjzIEPSg9GFU5yOekgFvXoeVZQVlUvPjJ0h5ynHP4K/cOxA4mj2H
      3v0juXD4G/YWhEt6Ad2PODvqeEovoftX3oaM4tz1NqQZujd5GyL0/w9DgsZe92m1feM9RrbenPgc
      QYxvom0bwwTDh4dTnwPI5Fv7NVSXRstw7pND3umlG0LIFB1DwSeDDPK5782jAwPFPXj+sOo/0DCU
      fCTEggeqxOmlQ5FmygTVjxTHHEUfCZnA3N5l8wxmf3INUfQRkFmMTdu759Dt8laUfXz/uNQLU86M
      46qxT9YM8Qu1Cyn6jFb8jimA33meEgwls9Q/ZhW/iRSk5DOOQ+kzlyKZe6PS5GLaw4+ib4GL/2Jf
      J/bIKlqIkq8QDq6WWu9C/CzYEji3aPvWJG673c3hsvnKFhekB3B8gD3S5GTaB0/t+wqRFslUjPhG
      M4WZfBZ8qSQr4gjVy8jmwy9l08xy/TvlssLka8UvNdPc0p1HjPAL3Q/XEDbfJL9kD421Dwy3x+C4
      WvUNrhmsPtnm85OGweqb1NnnhtFvv0y+2UqDmGr4ZaFlMPuM5vFurbZ73sx4JHLXp0qVKlWqVKn6
      a/Ubtnj49NmHgvYAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjUtMDctMjVUMTY6MDU6MTErMDI6MDC4
      WWHmAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDI1LTA3LTI1VDE2OjA1OjExKzAyOjAwyQTZWgAAAABJ
      RU5ErkJggg=="
    />
  </svg>
</template>

<script>
export default {};
</script>
